import { categories } from '@/mocks/homeData';

export default function CategoriesSection() {
  return (
    <section id="products" className="relative py-20 md:py-28 bg-background-900/40">
      <div className="section-padding max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="mb-14 md:mb-20 reveal">
          <p className="text-primary-400 text-xs font-semibold tracking-[0.25em] uppercase mb-4">
            What We Supply
          </p>
          <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold text-foreground-50 mb-4 max-w-3xl">
            Comprehensive Equipment
            <br />
            <span className="text-primary-400 italic font-heading">Solutions Portfolio</span>
          </h2>
          <p className="text-sm md:text-base text-foreground-400 max-w-xl">
            An overview of the spare part categories and brands we can commonly supply across heavy industries.
          </p>
        </div>

        {/* Categories Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 reveal">
          {categories.map((cat, index) => (
            <div
              key={cat.id}
              className="group relative overflow-hidden rounded-xl bg-background-900 border border-background-800/50 hover:border-primary-500/30 transition-all duration-500"
              style={{ animationDelay: `${index * 80}ms` }}
            >
              {/* Image */}
              <div className="relative h-52 md:h-60 overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.title}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-900 via-background-900/30 to-transparent"></div>
              </div>

              {/* Content */}
              <div className="p-5 md:p-6">
                <h3 className="text-base md:text-lg font-bold text-foreground-100 mb-2 tracking-wide group-hover:text-primary-400 transition-colors duration-300">
                  {cat.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {cat.description}
                </p>
              </div>

              {/* Hover indicator */}
              <div className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center bg-background-950/60 border border-foreground-700/20 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <i className="ri-arrow-right-up-line text-foreground-300 text-sm"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}